import { EditableFieldProps } from 'components/Shared/types';
import React from 'react';


const EditableFieldCombine = ({ editable, text, handleChange, itemId, editedText } : EditableFieldProps) => {
  return (
    <>
    <style>
      {`
        input::placeholder {
        color: #ccc;
        }
      `}
    </style>
      {!editable ? text :
        <input type="text" maxLength={3}  placeholder={text} value={editedText}  onChange={event => handleChange(event, itemId)} style={{width: '54px', textTransform:'uppercase'}} />
      }
    </>
  );
};

export default EditableFieldCombine;